import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private oauthService: OAuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // 1) Skip adding Authorization header if the request goes to S3 (amazonaws.com)
    if (request.url.includes('amazonaws.com')) {
      return next.handle(request);
    }

    const token = this.oauthService.getAccessToken();
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err && err.status === 401) {
          // Prefer refresh token flow to avoid nonce/state issues
          return from(this.oauthService.refreshToken()).pipe(
            switchMap(() => {
              const refreshed = this.oauthService.getAccessToken();
              const retried = refreshed ? request.clone({ setHeaders: { Authorization: `Bearer ${refreshed}` } }) : request;
              return next.handle(retried);
            }),
            catchError(() => throwError(() => err))
          );
        }
        return throwError(() => err);
      })
    );
  }
}
